import React, { useState } from "react";
import { Popover } from "antd";
import { useSlate } from "slate-react";
import { Editor, Transforms } from "slate";
import KoButton from "packages/button";
import KoIcon from '@kwapio/icons';

const GRID_SIZE = 10;

export const InsertTablePopoverButton = ({disabled}) => {
  const editor = useSlate();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState({ rows: 0, cols: 0 });

  const handleInsert = (rows, cols) => {
    if (rows > 0 && cols > 0) {
      const table = {
        type: "table",
        children: Array.from({ length: rows }).map(() => ({
          type: "table-row",
          children: Array.from({ length: cols }).map(() => ({
            type: "table-cell",
            children: [{ text: "" }]
          }))
        }))
      };
  
      // Insert table normally
      Transforms.insertNodes(editor, table);
  
      // ✅ Insert blank paragraph after the table AT ROOT LEVEL
      Transforms.insertNodes(
        editor,
        {
          type: "paragraph",
          children: [{ text: "" }]
        },
        { at: [editor.children.length] } // <--- THIS FIXES nested issue
      );
  
      // ✅ Focus first cell after slight delay
      setTimeout(() => {
        const [tableEntry] = Editor.nodes(editor, {
          match: n => !Editor.isEditor(n) && n.type === "table"
        });
  
        if (tableEntry) {
          const [, path] = tableEntry;
          const firstCellPath = path.concat([0, 0]); // table -> first row -> first cell
          const point = Editor.start(editor, firstCellPath);
          Transforms.select(editor, point);
        }
      }, 50);
  
      // ✅ Reset popover
      setOpen(false);
      setSelected({ rows: 0, cols: 0 });
    }
  };
  
  const content = (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0.5rem" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${GRID_SIZE}, 1fr)`,
          gap: "2px",
          marginBottom: "0.5rem"
        }}
      >
        {Array.from({ length: GRID_SIZE * GRID_SIZE }).map((_, index) => {
          const row = Math.floor(index / GRID_SIZE);
          const col = index % GRID_SIZE;
          const isSelected = row < selected.rows && col < selected.cols;

          return (
            <div
              key={index}
              onMouseEnter={() => setSelected({ rows: row + 1, cols: col + 1 })}
              onClick={() => handleInsert(row + 1, col + 1)}
              style={{
                width: "2rem",
                height: "2rem",
                backgroundColor: isSelected ? "#1677ff" : "#f0f0f0",
                border: "1px solid #ccc",
                cursor: "pointer"
              }}
            />
          );
        })}
      </div>
      {selected.rows > 0 && selected.cols > 0 && (
        <div style={{ fontSize: "1.2rem", color: "#333" }}>
          {selected.rows} × {selected.cols}
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={(visible) => {
        setOpen(visible);
        if (!visible) setSelected({ rows: 0, cols: 0 });
      }}
    >
      <KoButton
        type="text"
        iconBtn
        disabled={disabled}
        icon={<KoIcon width={20} height={20} name="TableOutlined" />} />
    </Popover>
  );
};
